import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ErrorBoundary } from "./ui/ErrorBoundary";
import { initGa4 } from "./lib/ga4";
import { installGlobalErrorReporting } from "./lib/errorReport";
import { initUiPrefs } from "./lib/uiPrefs";
import { registerSw } from "./lib/registerSw";
import { startOutbox } from "./lib/outbox";
import { warmBooksList } from "./book/bookData";
import { captureInstallPrompt } from "./lib/homeScreen";
import "./styles.css";

// GA4 1회 초기화(ID 없으면 no-op). 라우트 추적은 App 내부에서.
initGa4();
// 저장된 UI 환경설정(글자 크기·모션 최소화) 복원 — 첫 페인트 전에.
initUiPrefs();
// 렌더 **밖**에서 터진 것까지 본다(이벤트 핸들러·타이머·Phaser 루프·await).
// ErrorBoundary 는 렌더 중만 잡는다 — 이번에 겪은 월드 정지도 렌더 밖이었다.
installGlobalErrorReporting();
// 끊겨도 이미 받아 둔 화면은 뜨게 한다(빌드본에서만 — dev 는 캐시가 방해된다).
registerSw();
// 📮 지난번에 못 보낸 그림책을 올린다. 학교 와이파이가 끊긴 채 태블릿을 덮었어도,
// 다시 켜는 이 순간에 올라간다(그게 실제로 대부분을 해결한다).
startOutbox();
// 📲 크롬의 「홈 화면에 추가」 신호는 페이지가 뜰 때 한 번만 온다 — 보호자 화면이 열릴 때 들으면 이미 지나가 있다(lib/homeScreen).
captureInstallPrompt();
// ⏱ 책장 주소로 들어왔으면 화면 조각을 기다리지 않고 목록부터 받는다(`warmBooksList` 주석 — 조치계획서 ■2).
if (location.pathname === "/book" || location.pathname === "/book/") warmBooksList();

const container = document.getElementById("root");
if (!container) throw new Error("#root 엘리먼트를 찾을 수 없습니다.");

createRoot(container).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
